import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit, Output, EventEmitter, Input, SimpleChange } from '@angular/core';
import { promise } from 'protractor';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { SharedService } from 'src/app/Services/shared.service';
import { StorageService } from 'src/app/Services/storage.service';
import { VehicleLiveTrackService } from 'src/app/store/vehicle/reducer';
import * as Highcharts from 'src/assets/js/highcharts';
import 'src/assets/map-assets/markerClusterer';
declare const mapUtilityMapBox;
declare var google: any;
declare var MarkerClusterer: any;

@Component({
  selector: 'app-live-tracking',
  templateUrl: './live-tracking.component.html',
  styleUrls: ['./live-tracking.component.css']
})
export class LiveTrackingComponent implements OnInit {

  public vehicleCategorys: any = {
    moving: [],
    halt: [],
    lateUpdate: [],
    all: []
  };
  public vehicleRegNos: any = {};
  @Output() vehicleStatus = new EventEmitter();

  @Input() public set selectedVeh(val: string) {
    if (val !== undefined && Object.keys(val).length > 0 && this.mapObj != undefined) this.focus(val);
  }
  @Input() public set singleVeh(val: string) {
    // console.log("from parent component data------------>", val)
    this.socketData = {};
    if (val && Object.keys(val).length > 0) {
      this.isRoutePlot = false;
      if (this.vehicleSelected && this.plottedLines.length > 0) {
        for (let a = 0; a < this.plottedLines.length; a++) {
          this.plottedLines[a].setMap(null);
        }
      }
      if (this.gglRouteMarkers.length > 0) {
        for (let i = 0; i < this.gglRouteMarkers.length; i++) {
          if (this.googleMapMarkers[i] != undefined) {
            this.gglRouteMarkers[i].setMap(null);
          }
        }
      }
      this.showSingleVeh = true;
      this.singleVehData = val;
      this.showZoom = true;
      this.showInfoWindow = true;
      this.focusSingleVeh(val);
      if (this.activeVehGglMarkers.length > 0) {
        let index = this.activeVehGglMarkers.findIndex(e => e.id == val['reg']);
        google.maps.event.trigger(this.activeVehGglMarkers[index], 'click');
      }
    } else {
      this.showSingleVeh = false;
      this.isMarkerClicked = false;
      this.showInfoWindow = false;
      this.showTotalDistance = false;
    }
  }
  @Input() public set removeVeh(val: string) {
    if (val !== undefined && Object.keys(val).length > 0 && this.mapObj != undefined) {
      this.showSingleVeh = false;
      this.socketData = {};
      this.isMarkerClicked = false;
      this.showInfoWindow = false;
      this.showTotalDistance = false;
      this.removeSingleVeh(val);
    }
  }

  @Input() public set summaryInfo(val: string) {
    /*  setTimeout(()=>{
       if (val!== undefined && Object.keys(val).length > 0 && this.singleVeh) this.createSummary();
       else if(( val == undefined || Object.keys(val).length == 0 ) && this.singleVeh) this.deleteSummary();
     },500) */
  };
  @Input('height') mapHeight;
  @Input('class') mapClass;
  @Input() vehActiveStatus: boolean = true;

  @Input() gMapId: string = 'googleMapChart';

  value: any;
  values: boolean;
  notes = [];
  folders = [];
  public User_type: any;
  public floatLineData: any = [];
  public addMarker: any;
  public initialMapLoad: boolean = true;
  public map_marker_vehRegNo_style = 'hidden';
  public showRouteChart: boolean = false;
  public plotlineChart: any;
  public showSingleVeh: boolean = false;
  public singleVehData: any;

  //for map
  public selectedMap: string = 'osrm';
  // public selectedMap:string='google';
  public mapOptions = {
    scrollwheel: true,
    zoom: 7,
    maxZoom: 22,
    center: new google.maps.LatLng(12.9716, 77.5946),
    fullscreenControl: false,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP,
    },
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_CENTER,
    },
    streetViewControl: false,
  };
  private googleMapObj: any;
  public pathCoordinates: any = [];
  public googleMapMarkers: any = [];
  public deviceMarkerClusters: any;
  public globalGoogleMarker: any;
  public plotPath: any;
  public vehicleSelected: boolean = false;
  public gglRouteMarkers: any = [];
  public movingBusMarker: any;
  public routeMarker: any;
  public selSingleVeh: string = '';
  public isRoutePlot: boolean = false;
  public plottedLines: any = [];
  public activeVehGglMarkers: any = [];
  public infoWindow = new google.maps.InfoWindow();
  public infoWindowContent = '';
  public selectedMarker: any = '';

  public selectedSpeed: number = 200;
  public showSpeed: boolean = false;
  public speedSelectposition: string = '155px';

  public showInfoWindow: boolean = false;
  public showZoom: boolean = true;

  public totalDistance: any = 0;
  public chartData: any = [];
  public showTotalDistance: boolean = false;
  public isMarkerClicked: boolean = false;

  public socketData: any = {};
  public startingIteration: number = 0;
  public deltaLat;
  public deltaLng;
  private changesProcessed = false;
  private previousData: string;
  constructor(
    private share: SharedService,
    private api: ApiService,
    private map: MapService,
    private comService: CommonServices,
    private socketStore: VehicleLiveTrackService,
    public storage: StorageService,
    private routeservice: RouteService,
  ) {
    this.User_type = this.storage.get('userType');
    let user = this.storage.get('userInfo');
    if (user.defaultLoc) {
      this.mapOptions.center = new google.maps.LatLng(user.defaultLoc.lat, user.defaultLoc.lng)
      this.mapOptions.zoom = 9;
    }
    if (user && user.map) {
      this.selectedMap = user.map;
    }
    setTimeout(() => {
      if (this.selectedMap == 'google') {
        // this.plotRoutePath();
        this.googleMapObj = new google.maps.Map(document.getElementById(this.gMapId), this.mapOptions);
        const trafficLayer = new google.maps.TrafficLayer();
        trafficLayer.setMap(this.googleMapObj);
      }
    }, 10)
    // console.log('@@@@ live tracking triggered');
    this.share._subject.subscribe((data: any) => {
      // console.log(data,'service data');
      if (data.type == 'socketData') {
        const markers = [];
        // console.log("data.data----->>", data.data)
        let newData = data.data;
        // this.storage.setData({ storedData: data.data })


        data.data.map((item) => {
          // if (item.imei == '861359038057954')
          if (!this.showSingleVeh || (this.showSingleVeh && this.singleVehData['reg'] == item['reg'])) {
            if (this.selectedMap == 'google') {
              // console.log("item->>>>>>>>", item)
              this.formattingSocketData(item, newData);
              this.googleMarkerLiveChange(item);
            } else {
              this.osrmMarkerLiveChange(item);
            }
          }
        });

        // if (this.mapObj != undefined && (this.singleVeh==undefined || Object.keys(this.singleVeh).length >= 0)) 
        // console.log(markers);
        // this.updateAllMarkers(markers);
      } else if (data.type == 'plot_line') {
        this.drawLineChart(data);
        if (data.data && data.data.length > 0) {
          if (this.selectedMap == 'google') {
            this.isRoutePlot = true;
            this.gglPlotLine(data);
          }
        } else if (data.reset) {
          this.isRoutePlot = false;
          this.vehicleSelected = false;
          this.showTotalDistance = false;
          this.selectedMarker = '';
          this.showZoom = true;
          this.removeAllGglMarkers();
          this.selectedSpeed = 200;
          if (this.infoWindow) this.infoWindow.close();
          if (this.selectedMap == 'google') {
            this.changePlotSpeed(200);
          }
        }
      }
    });

    //   const chart = Highcharts.chart('container', {
    //     chart: {
    //         type: 'bar'
    //     },
    //     title: {
    //         text: 'Fruit Consumption'
    //     },
    //     xAxis: {
    //         categories: ['Apples', 'Bananas', 'Oranges']
    //     },
    //     yAxis: {
    //         title: {
    //             text: 'Fruit eaten'
    //         }
    //     },
    //     series: [{
    //         name: 'Jane',
    //         data: [1, 0, 4]
    //     }, {
    //         name: 'John',
    //         data: [5, 7, 3]
    //     }]
    // });

  }
  public mapObj: any;

  ngOnInit(): void {
    this.getRegNos();
    this.getCurrentVehicleLocation();
    // let user = this.storage.get('userInfo');
    // if(user && user.map){
    //   this.selectedMap = user.map;
    // }
  }


  ngOnChanges(changes: SimpleChange) {
    // console.log("changes['singleVeh']-------->>>>>>>", changes['singleVeh'])
    if (changes['singleVeh']) {
      const currentValue = changes['singleVeh'].currentValue;
      const previousValue = changes['singleVeh'].previousValue;
      const firstChange = changes['singleVeh'].firstChange;

      // console.log("firstChange--------------->", firstChange)
      if (firstChange) {
        // console.log('First change detected with value:', currentValue);

        if (Object.keys(currentValue).length === 0) {
          // console.log('Current value is empty object, resetting state...');
          this.vehicleSelected = false;
          this.showSingleVeh = false;
          this.socketData = {};
          this.isMarkerClicked = false;
          this.showInfoWindow = false;
          if (this.selectedMap === 'google') {
            this.changePlotSpeed(200);
          }

          setTimeout(() => {
            // console.log("oneTimeCalled--------------->",)
            this.getCurrentVehicleLocation();
          }, 50);

          if (this.googleMapObj) {
            this.googleMapObj.setZoom(9);
          }
          this.showSpeed = false;
        }

      } else {
        // console.log('Subsequent change detected with value:', currentValue);
        if (previousValue === undefined || previousValue === null) {
          // console.log('Previous value is undefined or null');
        } else if (this.isEmptyObject(previousValue)) {
          // console.log('Previous value is an empty object');
        } else {
          // console.log('Previous value:', previousValue);
        }

        if (!this.isEmptyObject(currentValue) && !this.deepEqual(currentValue, previousValue)) {
          // console.log('Data changed:', currentValue);
          this.vehicleSelected = true;
          this.showSingleVeh = true;
        } else {
          // console.log('No actual change detected, both values are identical');
          this.showSingleVeh = false;
        }

        this.showSpeed = true;
      }

      this.showTotalDistance = false;
    }

    if (changes['gMapId']) {
      this.showSpeed = false;
    }
  }


  isEmptyObject(obj: any): boolean {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  private deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true;

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
      return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (!this.deepEqual(obj1[key], obj2[key])) return false;
    }

    return true;
  }

  formattingSocketData(data, newData) {
    if (this.socketData[data.reg]) {
      let obj = {
        lat: +data.lat,
        lng: +data.lng,
        id: data.reg
      }
      const oldData = this.storage.get('storedData')
      // console.log("oldData->>>>>>>>>>", oldData)
      // if (oldData.filter(item => item.reg == data.reg).length > 0) {
      //   console.log("matchedobj________>", obj)
      //   console.log("newData------------<<<>?", newData)
      //   let endValue = oldData.filter(item => item.reg == data.reg)[0]
      //   console.log("endValue==============", endValue)
      //   obj['endLat'] = +endValue['lat']
      //   obj['endLng'] = +endValue['lng']
      //   console.log("objafterrrrrrrrrrrrrrrrr", obj)
      //   this.socketData[data.reg].push(obj);
      // }
      if (this.socketData[data.reg][this.socketData[data.reg].length - 1].lat != data.lat && this.socketData[data.reg][this.socketData[data.reg].length - 1].lng != data.lng) {
        // console.log("this.socketData=======>", obj)
        // if (oldData.filter(item => item.reg == obj.id).length > 0) {
        //   console.log("matchedobj________>", obj)
        //   console.log("newData------------<<<>?", newData)
        //   let endValue = oldData.filter(item => item.reg == obj.id)[0]
        //   console.log("endValue==============", endValue)
        //   obj['endLat'] = +endValue['lat']
        //   obj['endLng'] = +endValue['lng']
        //   console.log("objafterrrrrrrrrrrrrrrrr", obj)
        //   this.socketData[data.reg].push(obj);
        // } else {
        this.socketData[data.reg].push(obj);
        // }
      }
    } else {
      this.socketData[data.reg] = [];
      let obj = {
        lat: +data.lat,
        lng: +data.lng,
        id: data.reg
      }
      this.socketData[data.reg].push(obj);
      // console.log("this.socketData[data.reg]------->", this.socketData[data.reg])
    }
    this.socketData[data.reg] = this.socketData[data.reg].slice(-2);
  }
  osrmMarkerLiveChange(item) {
    let color = 'orange-dot';
    if (item.gpsts) {
      let currnentTMS = new Date().getTime();
      let gpsts = item.gpsts
      if ((gpsts + '').length <= 10) gpsts = gpsts * 1000;
      const timeDiff = this.comService.timeDiff(gpsts, currnentTMS);
      if (timeDiff.hh > 4) {
        color = 'orange-dot';
      } else {
        color = item.spd > 5 ? (item.spd < 60 ? 'green-dot' : 'blue-dot') : 'red-dot'
      }
    }
    const marker = {
      id: '_dashboard' + item.reg,
      content: `<div class="${color} " ></div>`,
      lat: parseFloat(item.lat),
      lng: parseFloat(item.lng),
      // lat: 12.987315434653826,
      // lng: 80.22082852957499,
      // bearing: true,
      popup: { content: item.near, open: false },
      cluster: 'dashboardMap'
    };
    try {
      if ((marker.lat < 90 && marker.lat > -90) && (marker.lng < 90 && marker.lng > -90)) {
        if (this.mapObj != undefined) {
          this.mapObj.marker(marker);
        }
      }
    } catch (err) {
      console.error('Marker Error!')
    }
    // markers.push(marker);
    // console.log('marker ', marker)

    // }
  }
  async googleMarkerLiveChange(item) {
    // let parent=this;
    let loc = {
      lat: +item.lat,
      lng: +item.lng,
    }
    // console.log("loc--------->", loc)
    let index = this.activeVehGglMarkers.findIndex((e) => e.id == item.reg);
    if (index != -1) {
      let image = {
        origin: new google.maps.Point(0, 0),
        scaledSize: new google.maps.Size(35, 30),
      };
      if (item.gpsts && item.gpsts != undefined) {
        let currnentTMS = new Date().getTime();
        let gpsts = item.gpsts
        if ((gpsts + '').length <= 10) gpsts = gpsts * 1000;
        const timeDiff = this.comService.timeDiff(gpsts, currnentTMS);
        if (timeDiff.hh > 4) {
          image['url'] = "assets/images/map/googleMap/grey_car.png";
        } else {
          image['url'] = item.spd > 5 && timeDiff.minute < 10 ? (item.spd < 60 ? 'assets/images/map/googleMap/yellow_car.png' : 'assets/images/map/googleMap/olive_car.png') : 'assets/images/map/googleMap/red_car.png'
        }
        // var mLatlng = new google.maps.LatLng(loc.lat, loc.lng);
        // console.log("ImageURL------------>", image)
        setTimeout(() => {
          this.transition(item.reg);
        }, 1000)
        this.activeVehGglMarkers[index].setIcon(image);

        // this.activeVehGglMarkers[index].setPosition(loc);
        if (this.infoWindow) this.infoWindow.close();
        this.infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + this.activeVehGglMarkers[index].id + '</span><div style="margin-top:2px">' + 'Updated :' + '<span>' + ' ' + this.comService.timestampToDate(this.activeVehGglMarkers[index].updated, 'DMY H:M:S') + '</span></div><div style="margin-top:2px">' + 'Speed :' + ' ' + '<span>' + this.activeVehGglMarkers[index].speed + ' ' + 'kmph' + '</span>' + '</div><div style="margin-top:2px">' + 'Location :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + (this.activeVehGglMarkers[index].loc ? this.activeVehGglMarkers[index].loc : '---') + ' ' + '</span>' + '</div>' + '</div>';
        this.infoWindow.setContent(this.infoWindowContent);
        if (this.selectedMarker != '') {
          if (this.selectedMarker.id == this.activeVehGglMarkers[index].id) {
            // if(this.infoWindow) this.infoWindow.close();
            // this.infoWindow.open(this.googleMapObj,this.selectedMarker);
            google.maps.event.trigger(this.selectedMarker, 'click');
          }
        }
      }
    } else {
      let marker = await this.createGoogleMarker(item);
      marker.addListener('click', (e) => {
        this.isMarkerClicked = true;
        if (this.showSingleVeh) {
          this.selectedMarker = marker;
        }
        if (this.infoWindow) this.infoWindow.close();
        let content = '<div class="window-content-container"><span style="font-weight:700">' + item.reg + '</span>';
        content += '<div style="margin-top:2px">' + 'Updated :' + '<span>' + ' ' + this.comService.timestampToDate(item.gpsts * 1000, 'DMY H:M:S') + '</span></div>';
        content += '<div style="margin-top:2px">' + 'Speed :' + ' ' + '<span>' + item.spd + ' ' + 'kmph' + '</span>' + '</div>';
        if (item.near) {
          content += '<div style="margin-top:2px;">' + 'Location :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + item.near + ' ' + '</span>' + '</div>';
        }
        if (item?.locSts !== undefined) {
          const locStatus = item?.locSts == '1' ? "On" : item?.locSts == '0' ? 'Off' : '';
          if (locStatus) {
            content += '<div style="margin-top:2px;">' + 'Location status :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + locStatus + ' ' + '</span>' + '</div>';
          }
        }
        if (item?.bOptSts !== undefined) {
          const bgStatus = item?.bOptSts == '1' ? "On" : item?.bOptSts == '0' ? 'Off' : '';
          if (bgStatus) {
            content += '<div style="margin-top:2px;">' + 'Background status :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + bgStatus + ' ' + '</span>' + '</div>';
          }
        }
        if (item?.appUse !== undefined) {
          const appStatus = item?.appUse > "0" ? this.comService.convertSecondsToMinutes(item?.appUse) : '---';
          if (appStatus) {
            content += '<div style="margin-top:2px;">' + 'App usage :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + appStatus + ' ' + '</span>' + '</div>';
          }
        }
        if (item?.ibatt !== undefined) {
          content += '<div style="margin-top:2px;">' + 'Battery percentage :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + item?.ibatt + '%' + ' ' + '</span>' + '</div>';
        }

        if (item?.appVer !== undefined) {
          content += '<div style="margin-top:2px;">' + 'App version :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + item?.appVer + ' ' + '</span>' + '</div>';
        }

        content += '</div>';

        this.infoWindowContent = content;
        this.infoWindow.setContent(this.infoWindowContent);
        if (this.showZoom) {
          this.googleMapObj.panTo(marker.position);
          this.googleMapObj.setZoom(15);
          //   this.smoothZoom(this.googleMapObj, 15, this.googleMapObj.getZoom(),marker);
          setTimeout(() => {
            this.infoWindow.open(this.googleMapObj, marker);
          }, 1000)
        } else {
          if (this.showInfoWindow) {
            this.infoWindow.open(this.googleMapObj, marker);
          }
        }
        this.showZoom = false;
      })
      // marker.addListener('mouseover',(e)=>{
      //   this.infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + item.reg + '</span><div style="margin-top:2px">'+'Updated44 :'+'<span>'+' '+this.comService.timestampToDate(item.gpsts*1000,'DMY H:M:S')+'</span></div><div style="margin-top:2px">'+'Speed :'+' '+'<span>'+item.spd+' '+'kmph' +'</span>'+'</div><div style="margin-top:2px;">'+'Location :'+' '+'<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">'+(item.near?item.near:'---')+' '+'</span>'+'</div><div style="margin-top:2px;">'+'Location status :'+' '+'<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">'+(item?.locSts == '1'?"On":item?.locSts == '0'? 'Off':'')+' '+'</span>'+'</div><div style="margin-top:2px;">'+'Background status :'+' '+'<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">'+(item?.bOptSts == '1'?"On":item?.bOptSts == '1'? 'Off':'')+' '+'</span>'+'</div><div style="margin-top:2px;">'+'App usage status :'+' '+'<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">'+(item?.appUse == '1'?"On":item?.appUse == '0'? 'Off':'')+' '+'</span>'+'</div><div style="margin-top:2px;">'+'Battery percentage :'+' '+'<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">'+(item?.ibatt ?item?.ibatt:'')+'%'+' '+'</span>'+'</div>'+'</div>';
      //   this.infoWindow.setContent(this.infoWindowContent);
      //   this.infoWindow.open(this.googleMapObj, marker);
      //   this.showInfoWindow=true;
      // })
      marker.addListener('mouseover', (e) => {
        let content = '<div class="window-content-container"><span style="font-weight:700">' + item.reg + '</span>';
        content += '<div style="margin-top:2px">' + 'Updated :' + '<span>' + ' ' + this.comService.timestampToDate(item.gpsts * 1000, 'DMY H:M:S') + '</span></div>';
        content += '<div style="margin-top:2px">' + 'Speed :' + ' ' + '<span>' + item.spd + ' ' + 'kmph' + '</span>' + '</div>';
        if (item.near) {
          content += '<div style="margin-top:2px;">' + 'Location :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + item.near + ' ' + '</span>' + '</div>';
        }
        if (item?.locSts !== undefined) {
          const locStatus = item?.locSts == '1' ? "On" : item?.locSts == '0' ? 'Off' : '';
          if (locStatus) {
            content += '<div style="margin-top:2px;">' + 'Location status :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + locStatus + ' ' + '</span>' + '</div>';
          }
        }
        if (item?.bOptSts !== undefined) {
          const bgStatus = item?.bOptSts == '1' ? "On" : item?.bOptSts == '0' ? 'Off' : '';
          if (bgStatus) {
            content += '<div style="margin-top:2px;">' + 'Background status :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + bgStatus + ' ' + '</span>' + '</div>';
          }
        }
        if (item?.appUse !== undefined) {
          const appStatus = item?.appUse > "0" ? this.comService.convertSecondsToMinutes(item?.appUse) : '---';
          if (appStatus) {
            content += '<div style="margin-top:2px;">' + 'App usage :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + appStatus + ' ' + '</span>' + '</div>';
          }
        }
        if (item?.ibatt !== undefined) {
          content += '<div style="margin-top:2px;">' + 'Battery percentage :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + item?.ibatt + '%' + ' ' + '</span>' + '</div>';
        }
        if (item?.appVer !== undefined) {
          content += '<div style="margin-top:2px;">' + 'App version :' + ' ' + '<span style="display:inline-block;width: 250px;white-space: nowrap;text-overflow: ellipsis;">' + item?.appVer + ' ' + '</span>' + '</div>';
        }

        content += '</div>';

        this.infoWindowContent = content;
        this.infoWindow.setContent(this.infoWindowContent);
        this.infoWindow.open(this.googleMapObj, marker);
        this.showInfoWindow = true;
      });

      marker.addListener('mouseout', (e) => {
        if (!this.isMarkerClicked) {
          this.infoWindow.close();
          this.showInfoWindow = false;
        }
      })
      google.maps.event.addListener(this.infoWindow, 'closeclick', (e) => {
        this.isMarkerClicked = false;
        this.showInfoWindow = false;
      })
      // marker.setMap(this.googleMapObj);
      this.activeVehGglMarkers.push(marker);
      this.activeVehGglMarkers = this.removeDuplicates(this.activeVehGglMarkers);
      let selIndex = this.activeVehGglMarkers.findIndex(e => e.id == marker.id);
      this.activeVehGglMarkers[selIndex].setMap(this.googleMapObj);
      // google.maps.event.addDomListener(this.googleMapObj, 'zoom_changed', function(e) {
      //   let zoom = this.googleMapObj.getZoom();
      //   if(zoom<15){
      //     this.showZoom=true;
      //   }else{
      //     this.showZoom=false;
      //   }
      // });
    }
    // const clusteringOptions = {
    //   styles:[{
    //         url: "assets/images/map/googleMap/m1.png",
    //         width: 53,
    //         height:53,
    //         textSize:12,
    //         textColor:"white",
    //       }],
    //       minimumClusterSize:2,
    //       maxZoom:14
    // };
    // if(this.googleMapObj){
    //   this.deviceMarkerClusters = new MarkerClusterer(
    //     this.googleMapObj, this.activeVehGglMarkers,
    //     clusteringOptions);
    // }
    // let infoWindowContent;
    // let infowindow;
    // marker.addListener('click',(e)=>{
    //   if(infowindow) infowindow.close();
    //   infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + item.reg + '</span><div style="margin-top:2px">'+'Updated :'+'<span>'+' '+this.comService.timestampToDate(item.gpsts*1000)+'</span></div><div style="margin-top:2px">'+'Speed :'+' '+'<span>'+item.spd+' '+'kmph' +'</span>'+'</div>'+'</div>';
    //   infowindow = new google.maps.InfoWindow({
    //     content: infoWindowContent
    //   });
    //   this.googleMapObj.setZoom(15);
    //   this.googleMapObj.panTo(loc);
    // })
    // google.maps.event.addListener(marker, 'click', function() {
    //   infowindow.open(this.googleMapObj, this);
    // });
  }
  transition(vehicle) {
    this.startingIteration = 0;
    let position = this.socketData[vehicle];
    if (position && position.length > 0) {
      if (position.length >= 2) {
        this.deltaLat = (position[position.length - 1].lat - position[position.length - 2].lat) / 100;
        this.deltaLng = (position[position.length - 1].lng - position[position.length - 2].lng) / 100;
      } else {
        this.deltaLat = 0;
        this.deltaLng = 0;
      }
      this.markerpositionChange(vehicle);
    }
  }
  calculateBearing(lat1, lng1, lat2, lng2) {
    // console.log("insodeeeeee the funciton------>")
    const toRad = (x) => (x * Math.PI) / 180;
    const toDeg = (x) => (x * 180) / Math.PI;

    const dLng = toRad(lng2 - lng1);
    const y = Math.sin(dLng) * Math.cos(toRad(lat2));
    const x = Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
      Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLng);

    let bearing = toDeg(Math.atan2(y, x));
    bearing = (bearing + 360) % 360; // Normalize the bearing to 0-360 degrees

    return bearing;
  }


  async markerpositionChange(vehicle) {
    // console.log("this.socketData[]=============>>>>", this.socketData)
    let position = this.socketData[vehicle];
    // console.log("this.socketData[position]=============>>>>", position)
    let latlng;

    if (position && position.length > 0) {
      if (position.length === 1) {
        let startLat = 8.880000;
        let startLng = 77.940000;

        let lat1 = startLat;
        let lng1 = startLng;
        let lat2 = position[0].lat;
        let lng2 = position[0].lng;

        // let bearing = this.calculateBearing(lat1, lng1, lat2, lng2);

        latlng = new google.maps.LatLng(position[0].lat, position[0].lng);

        let index = this.activeVehGglMarkers.findIndex(e => e.id == vehicle);

        if (index != -1) {

          // this.activeVehGglMarkers[index].setIcon({
          //   path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          //   rotation: bearing,
          //   scale: 5,
          //   fillColor: '#FF0000',
          //   fillOpacity: 0.8,
          //   strokeWeight: 2
          // });

          // let image = this.activeVehGglMarkers[index].getIcon() || {};
          // const rotatedIcon = await this.getRotatedIcon(image.url, bearing, 35, 30);
          // console.log("rotatedIcon===========>", rotatedIcon)

          // if (rotatedIcon && (rotatedIcon as { url: string }).url) {

          this.activeVehGglMarkers[index].setPosition(latlng);
          //   this.activeVehGglMarkers[index].setIcon({
          //     url: (rotatedIcon as { url: string }).url,
          //     scaledSize: new google.maps.Size(35, 30),
          //     anchor: new google.maps.Point(17.5, 15)
          //   });
          // } else {
          //   console.error("Invalid icon format:", rotatedIcon);
          // }
        }
      }
      else if (position.length >= 2) {
        let lat1 = position[position.length - 2].lat + this.deltaLat;
        let lng1 = position[position.length - 2].lng + this.deltaLng;
        let lat2 = position[position.length - 1].lat;
        let lng2 = position[position.length - 1].lng;

        let bearing = this.calculateBearing(lat1, lng1, lat2, lng2);

        latlng = new google.maps.LatLng(lat2, lng2);
        // console.log("position---------->", position,bearing)

        let index = this.activeVehGglMarkers.findIndex(e => e.id == vehicle);
        if (index != -1) {
          let image = this.activeVehGglMarkers[index].getIcon() || {};

          // this.activeVehGglMarkers[index].setIcon({
          //   path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          //   rotation: bearing,
          //   scale: 5,
          //   fillColor: '#FF0000',
          //   fillOpacity: 0.8,
          //   strokeWeight: 2
          // });

          const rotatedIcon = await this.getRotatedIcon(image.url, bearing, 35, 30);
          // console.log("rotatedIcon===========>", rotatedIcon)

          if (rotatedIcon && (rotatedIcon as { url: string }).url) {

            this.activeVehGglMarkers[index].setPosition(latlng);
            this.activeVehGglMarkers[index].setIcon({
              url: (rotatedIcon as { url: string }).url,
              scaledSize: new google.maps.Size(35, 30),
              anchor: new google.maps.Point(17.5, 15)
            });
          } else {
            // console.error("Invalid icon format:", rotatedIcon);
          }
        }
      }

      if (this.startingIteration != 100) {
        this.startingIteration++;
        setTimeout(() => this.markerpositionChange(vehicle), 10);
      }
    }
  }


  getRotatedIcon(url, angle, width, height) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      // Handle CORS issues if the image is from an external source
      img.crossOrigin = 'Anonymous';

      img.src = url;

      img.onload = () => {
        try {
          // Manually define a higher pixel ratio for sharper images
          const pixelRatio = 3; // Adjust for resolution

          // Create an off-screen canvas
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          // Set canvas size considering the higher pixel ratio
          canvas.width = width * pixelRatio;
          canvas.height = height * pixelRatio;

          // Scale the drawing operations by the pixel ratio
          context.scale(pixelRatio, pixelRatio);

          // Clear the canvas
          context.clearRect(0, 0, canvas.width, canvas.height);

          // Save the current canvas state
          context.save();

          // Move the origin to the center of the image
          context.translate(width / 2, height / 2);

          // Rotate the canvas by the desired angle (in radians)
          context.rotate((angle * Math.PI) / 180);

          // Draw the image onto the canvas, rotating it
          context.drawImage(img, -width / 2, -height / 2, width, height);

          // Restore the canvas state
          context.restore();

          // Convert the canvas to a base64-encoded image (data URL)
          const rotatedImageUrl = canvas.toDataURL('image/png', 1.0); // Max quality for base64

          // Return a valid Google Maps icon object with normal display size
          resolve({
            url: rotatedImageUrl,
            scaledSize: new google.maps.Size(width, height), // Display size remains normal
            anchor: new google.maps.Point(width / 2, height / 2) // Adjust anchor point to center
          });
        } catch (error) {
          reject(`Image processing failed: ${error.message}`);
        }
      };

      img.onerror = (error) => {
        console.error(`Failed to load image: ${url}`, error);
        reject(`Failed to load image: ${url}`);
      };
    });
  }


  removeDuplicates(arr) {
    let x = [];
    const unique = arr.filter(element => {
      const isDuplicate = x.includes(element.id);

      if (!isDuplicate) {
        x.push(element.id);

        return true;
      } else {
        return false;
      }
    });
    return unique;
  }
  smoothZoom(map, max, cnt, marker) {
    let parent = this;
    if (cnt >= max) {
      return;
    }
    else {
      let z = google.maps.event.addListener(map, 'zoom_changed', function (event) {
        google.maps.event.removeListener(z);
        parent.smoothZoom(map, max, cnt + 1, marker);
      });
      setTimeout(function () { map.setZoom(cnt) }, 100);
      map.panTo(marker.position);
    }
  }
  createGoogleMarker(data) {
    let loc = {
      lat: +data.lat,
      lng: +data.lng,
    }
    let image = {
      origin: new google.maps.Point(0, 0),
      scaledSize: new google.maps.Size(35, 30),
    };
    if (data.gpsts && data.gpsts != undefined) {
      let currnentTMS = new Date().getTime();
      let gpsts = data.gpsts
      if ((gpsts + '').length <= 10) gpsts = gpsts * 1000;
      const timeDiff = this.comService.timeDiff(gpsts, currnentTMS);
      if (timeDiff.hh > 4 && timeDiff.hh < 72) {
        image['url'] = "assets/images/map/googleMap/grey_car.png";
      } else {

        image['url'] = data.spd > 5 && timeDiff.minute < 10 ? (data.spd < 60 ? 'assets/images/map/googleMap/yellow_car.png' : 'assets/images/map/googleMap/olive_car.png') : 'assets/images/map/googleMap/red_car.png'
      }
      let marker = new google.maps.Marker({
        position: loc,
        icon: image,
        updated: data.gpsts,
        speed: data.spd,
        id: data.reg,
        loc: data.near
      })
      return marker;
    }
  }
  removeAllGglMarkers() {
    if (this.plottedLines.length > 0) {
      for (let a = 0; a < this.plottedLines.length; a++) {
        this.plottedLines[a].setMap(null);
      }
    }
    if (this.gglRouteMarkers.length > 0) {
      for (let i = 0; i < this.gglRouteMarkers.length; i++) {
        this.gglRouteMarkers[i].setMap(null);
      }
    }
    if (this.movingBusMarker) {
      this.movingBusMarker.setMap(null);
    }
    if (this.routeMarker) {
      this.routeMarker.setMap(null);
    }
    if (this.plotPath) {
      this.plotPath.setMap(null);
    }
    this.gglRouteMarkers = [];
    this.plottedLines = [];
  }
  toDateFormat(value) {
    if (!value) return '';
    let date: any = new Date(value);
    var str = ("00" + (date.getDate() + 1)).slice(-2)
      + "/" + ("00" + date.getMonth()).slice(-2)
      + "/" + date.getFullYear() + " "
      + ("00" + date.getHours()).slice(-2) + ":"
      + ("00" + date.getMinutes()).slice(-2)
      + ":" + ("00" + date.getSeconds()).slice(-2);
    return str;
  }
  plotRoutePath() {
    if (this.selectedMap == 'google') {
      this.share._subject.subscribe((data: any) => {
        if (data.type == 'plot_line' && !data.reset) {
          this.isRoutePlot = true;
          this.gglPlotLine(data);
          this.drawLineChart(data);
        } else if (data.type == 'plot_line' && data.reset) {
          this.isRoutePlot = false;
          if (this.vehicleSelected && this.plottedLines.length > 0) {
            for (let a = 0; a < this.plottedLines.length; a++) {
              this.plottedLines[a].setMap(null);
            }
          }
          this.plottedLines = [];
          if (this.gglRouteMarkers.length > 0) {
            for (let i = 0; i < this.gglRouteMarkers.length; i++) {
              this.gglRouteMarkers[i].setMap(null);
            }
          }
          this.gglRouteMarkers = [];
          if (this.movingBusMarker) {
            this.movingBusMarker.setMap(null);
          }
          if (this.routeMarker) {
            this.routeMarker.setMap(null);
          }
        }
      })
    }
  }
  moveMarker(map, marker, lat, lng) {
    marker.setPosition(new google.maps.LatLng(lat, lng));
    // map.panTo(new google.maps.LatLng(lat, lng));
    // let bounds = new google.maps.LatLngBounds();
    // let mLatlng = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

    // bounds.extend(mLatlng);

    // map.fitBounds(bounds);
  }
  async gglPlotLine(data) {
    this.gglRouteMarkers = [];
    this.pathCoordinates = [];
    if (Object.keys(data).length > 0) {
      for (let i = 0; i < data['data'].length; i++) {
        let loc = {
          lat: +data.data[i][0],
          lng: +data.data[i][1],
          speed: +data.data[i][3],
          updated: +data.data[i][4]
        }
        if (i == 0) {
          loc['position'] = 'start';
        } else if (i == data['data'].length - 1) {
          loc['position'] = 'end';
        }
        this.pathCoordinates.push(loc);
      }
    }
    // for arrow to show direction
    let indexArr = [];
    if (this.pathCoordinates.length <= 10) {
      let result = Math.round(this.pathCoordinates.length / 2);
      indexArr.push(result);
    } else {
      for (let a = 0; a < this.pathCoordinates.length - 1; a++) {
        if (this.pathCoordinates.length <= 500) {
          if (a / 10 >= 1 && a % 10 == 0) {
            indexArr.push(a);
          }
        } else {
          if (a / 20 >= 1 && a % 20 == 0) {
            indexArr.push(a);
          }
        }
      }
    }
    this.movingBusMarker = new google.maps.Marker({ map: this.googleMapObj, icon: 'assets/images/map/googleMap/bus_main.png' });
    let infoWindowContent;
    let infowindow;
    let filVal;
    for (let i = 0; i < this.pathCoordinates.length; i++) {
      let image = {
        origin: new google.maps.Point(0, 0),
      };
      let marker: any;
      if (this.isRoutePlot) {
        //set marker based on speed
        marker = await this.setLiveTrackingMarker(this.pathCoordinates[i], i);
        try {
          if (i == 0) {
            this.googleMapObj.setZoom(13);
          }
          this.googleMapObj.panTo(marker.position);
        } catch (e) {
          console.log(e);
        }
        if (marker != undefined) {
          this.gglRouteMarkers.push(marker);
        } else {
          return;
        }
        if (this.gglRouteMarkers[i] != undefined) {
          this.gglRouteMarkers[i].addListener('click', (e) => {
            this.googleMapObj.setZoom(15);
            this.googleMapObj.panTo(this.gglRouteMarkers[i].position);
            filVal = this.pathCoordinates.filter(obj => e.latLng.lat() == obj.lat && e.latLng.lng() == obj.lng);
            if (infowindow) infowindow.close();
            if (filVal.length > 0) {
              infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + this.selSingleVeh + '</span><div style="margin-top:2px">' + 'Updated :' + '<span>' + ' ' + this.comService.timestampToDate(filVal[0].updated, 'DMY H:M:S') + '</span></div><div style="margin-top:2px">' + 'Speed :' + ' ' + '<span>' + filVal[0].speed + ' ' + 'kmph' + '</span>' + '</div>' + '</div>';
              infowindow = new google.maps.InfoWindow({
                content: infoWindowContent
              });
            }
          })
          google.maps.event.addListener(this.gglRouteMarkers[i], 'click', function () {
            infowindow.open(this.googleMapObj, this);
          });
        }
        // this.plotPath.getPath().push(new google.maps.LatLng(this.pathCoordinates[i].lat, this.pathCoordinates[i].lng));
        if (i != this.pathCoordinates.length - 1) {
          this.moveMarker(this.googleMapObj, this.movingBusMarker, this.pathCoordinates[i].lat, this.pathCoordinates[i].lng);
        } else {
          if (this.movingBusMarker) {
            this.movingBusMarker.setMap(null);
          };
        }
      } else {
        break;
      }
      //draw line
      if (i > 0) {
        let line = await this.setLiveTrackingLine(this.pathCoordinates[i], i, indexArr)
        this.plotPath = line;
        this.plottedLines.push(line);
        this.plotPath.setMap(this.googleMapObj);
      }
    }
  }
  setLiveTrackingMarker(data, i) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let marker;
        let image = {
          origin: new google.maps.Point(0, 0),
        };
        try {
          if (data.position == 'start') {
            image['url'] = "assets/images/map/googleMap/start.png";
            image['scaledSize'] = new google.maps.Size(30, 35);
          } else if (data.position == 'end') {
            image['url'] = "assets/images/map/googleMap/finish.png";
            image['scaledSize'] = new google.maps.Size(30, 35);
          } else if (data.speed <= 5) {
            image['url'] = "assets/images/map/googleMap/red_dot.png";
            image['scaledSize'] = new google.maps.Size(10, 10);
          } else {
            image['url'] = "assets/images/map/googleMap/empty_marker.png";
          }
          // else if (data.speed >= 60) {
          //   image['url']= "assets/images/map/googleMap/olive_dot.png";
          //   image['scaledSize']=new google.maps.Size(10,10);
          // } else if (data.speed <= 5) {
          //   image['url']= "assets/images/map/googleMap/red_dot.png";
          //   image['scaledSize']=new google.maps.Size(10,10);
          // } else if (data.speed > 5 && data.speed <60) {
          //   image['url']= "assets/images/map/googleMap/yellow_dot.png";
          //   image['scaledSize']=new google.maps.Size(10,10);
          // }
          if (this.isRoutePlot) {
            marker = new google.maps.Marker({
              position: data,
              map: this.googleMapObj,
              icon: image
            });
          }
          resolve(marker);
        } catch (error) {
          console.log(error);
        }
      }, this.selectedSpeed)
    })
  }
  setLiveTrackingLine(data, i, indexArr) {
    let arr = [];
    if (i > 0) {
      arr[0] = this.pathCoordinates[i];
      arr[1] = this.pathCoordinates[i - 1];
      let line;
      return new Promise((resolve, reject) => {
        try {
          const lineSymbol = {
            path: google.maps.SymbolPath.BACKWARD_CLOSED_ARROW,
            strokeColor: 'black',
            strokeWeight: 2,
            scale: 3
          };
          for (let a = 0; a < indexArr.length; a++) {
            if (i == indexArr[a]) {
              line = new google.maps.Polyline({
                path: arr,
                geodesic: true,
                strokeColor: "#57ABED",
                strokeOpacity: 1.0,
                strokeWeight: 4,
                visible: true,
                icons: [
                  {
                    icon: lineSymbol,
                    offset: "50%",
                  },
                ],
              });
              break;
            } else {
              line = new google.maps.Polyline({
                path: arr,
                geodesic: true,
                strokeColor: "#57ABED",
                strokeOpacity: 1.0,
                strokeWeight: 4,
                visible: true
              })
            }
          }
          resolve(line);
        } catch (error) {
          console.log(error);
        }
      })
    }
  }
  async drawLineChart(data) {
    if (data && data['reset'] !== undefined) {
      // console.log('reset in list view');          
      this.removeLine();
      this.showRouteChart = false;
      this.removeLineChart();
      this.floatLineData = [];
    } else {
      this.floatLineData = [...this.floatLineData, ...data.data];
      try {
        this.chartData = this.floatLineData;
        this.floatLineData = await this.processData(this.floatLineData, 0);

        if (this.floatLineData.length > 0) {
          this.showRouteChart = true;
          if (this.selectedMap != 'google') {
            this.plotSingleVehicleLine(this.floatLineData);
          }
          let data: any = [];
          this.floatLineData.map((item) => {
            // let pushArr = [item[4].length>10?item[4]:item[4]*1000,Number(item[3]),];
            let pushArr = { x: item[4], y: Number(item[3]), distance: Number(Math.round((item['distance'] + Number.EPSILON) * 100) / 100) }
            if (Number(item[3]) < 5) pushArr['marker'] = { fillColor: '#BF0B23' };
            data.push(pushArr);
          })
          // let travelEtaDist:any = { 'eta': 0, 'distance': 0 };
          // let arr=[];
          // let loc1={
          //   lat : this.floatLineData[0][0],
          //   lng : this.floatLineData[0][1]
          // }
          // let loc2={
          //   lat : this.floatLineData[this.floatLineData.length-1][0],
          //   lng : this.floatLineData[this.floatLineData.length-1][1]
          // }
          // travelEtaDist = await this.routeservice.findETADist(loc1,loc2).catch((err)=>console.log(err));
          // console.log(travelEtaDist)
          // for(let i=0;i<this.floatLineData.length;i++){
          //   if(i!=0){
          //   }
          //   // arr.push(travelEtaDist['distance']);
          //   // console.log(arr)
          //   // let distance=0;
          //   // for(let j=0;j<arr.length;j++){
          //   //   distance =distance + arr[j];
          //   // }
          //   // this.floatLineData[i]['distance']=distance;
          // }
          // console.log(this.floatLineData);
          this.createLineChart(data);
        }
      } catch (err) {
        console.error('Marker Error!')
      }
    }
  }
  processData(data: any, speed: any) {
    return new Promise((resolve, reject) => {
      try {
        let totalDis: any = 0;
        const procesedData: any = [];
        const speedLimit = ((speed == undefined) || (speed == null) || (speed == '')) ? 0 : speed;
        const sortingData = {};
        data.map((item) => {
          item.date = this.comService.timestampToDate(item[4], 'DMY H:M:S');
          if (item[4] != undefined && +item[3] >= +speedLimit) {
            sortingData[item[4]] = item;
          }
        });
        const objKeys = Object.keys(sortingData);
        if (objKeys && objKeys.length) {
          let ind = 1;
          const temp: any = [];
          const tempEx = [];
          for (let i = 0; i < objKeys.length; i++) {
            let prevKey = null, next = null, currentKey = objKeys[i], pre = null;

            if (i > 0) { prevKey = procesedData[procesedData.length - 1]; }
            if (objKeys[i + 1]) { next = objKeys[i + 1]; }
            let curdis = 0;
            if (i > 0) {
              pre = objKeys[i - 1];
              const lat1 = parseFloat(sortingData[currentKey][0]);
              const lat2 = parseFloat(sortingData[pre][0]);
              const lng1 = parseFloat(sortingData[currentKey][1]);
              const lng2 = parseFloat(sortingData[pre][1]);
              if ((lat1 == lat2) && (lng1 == lng2)) { curdis = 0; } else {
                const radlat1 = Math.PI * lat1 / 180.0;
                const radlat2 = Math.PI * lat2 / 180.0;
                const theta = lng1 - lng2;
                const radtheta = Math.PI * theta / 180.0;
                let dist: any = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                  dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                dist = (dist * 1.609344);
                curdis = parseFloat(dist);
              }
            }
            totalDis = parseFloat(totalDis) + curdis;
            data[i]['distance'] = totalDis;
          }
        }
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }
  createLineChart(data?) {
    let container;
    let id;
    // if(this.selectedMap=='google'){
    //   container = document.getElementById(this.gMapId);
    //   id=this.gMapId;
    // }else{
    // }
    container = document.getElementById('routeChartContainer');
    id = 'routeChartContainer';
    container.style.display = 'inline-block';
    container.style.height = '100px';
    const parent = this;
    this.plotlineChart = Highcharts.chart(id, {
      chart: {
        zoomType: 'x',
        backgroundColor: '#ffffffa3',
        events: {
          selection: async function (event) {
            if (event.xAxis) {
              let min = event.xAxis[0].min;
              let max = event.xAxis[0].max;
              let minValArr = parent.chartData.filter((e) => min <= e[4]);
              let maxValArr = parent.chartData.filter((e) => max >= e[4]);
              let startpoint = parent.chartData.findIndex(e => e == minValArr[0]);
              let endPoint = parent.chartData.findIndex(e => e == maxValArr[maxValArr.length - 1]);
              let data = parent.chartData.slice(startpoint, endPoint);
              data = await parent.processData(data, 0);
              if (data.length > 0) {
                parent.totalDistance = Number((data[data.length - 1].distance).toFixed(2));
              } else {
                parent.totalDistance = 0;
              }
              parent.showTotalDistance = true;
            } else {
              parent.showTotalDistance = false;
            }
          }
        },
      },
      title: {
        text: ''
      },
      credits: {
        position: {
          align: 'left',
          x: 5,
        }
      },
      subtitle: {
        text: 'Click and drag in the plot area to zoom in',
        floating: true,
        style: {
          color: 'rgb(108 108 108)',
          fontSize: '13px'
        }
      },
      tooltip: {
        formatter: function () {
          let point = data.filter((e) => e.x == this.x && e.y == this.y);
          let distance = point[0]['distance'];
          return '<b>Date & Time : </b>' + parent.comService.timestampToDate(this.x, 'DMY H:M:S') + '<br><b>Speed : </b>' + Number(this.y) + 'kmph'
            + '<br><b>Distance : </b>' + distance + 'kms';
        }
      },
      xAxis: {
        type: 'datetime',
        labels: {
          formatter: function () {
            return parent.comService.timestampToDate(this.value, 'H:M:S');
          }
        }
      },
      yAxis: {
        title: {
          text: 'Speed'
        },
        height: '100%',
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, Highcharts.getOptions().colors[0]],
              [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
            ]
          },
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: null
        },
        series: {
          point: {
            events: {
              mouseOver: function () {
                if (parent.routeMarker) {
                  parent.routeMarker.setMap(null);
                }
                let lat, lng;
                parent.floatLineData.filter((item) => {
                  if (item.includes(this.x)) {
                    lat = item[0];
                    lng = item[1];
                  }
                })
                if (parent.selectedMap == 'google') {
                  let location = {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                  }
                  let image = {
                    scaledSize: new google.maps.Size(30, 35),
                    url: "assets/images/map/googleMap/routeMarker.png"
                  };
                  parent.routeMarker = new google.maps.Marker({
                    position: location,
                    map: parent.googleMapObj,
                    icon: image
                  })
                  parent.moveMarker(parent.googleMapObj, parent.routeMarker, lat, lng);
                  parent.googleMapObj.panTo(new google.maps.LatLng(lat, lng));
                } else {
                  let marker = {
                    id: '_dashboardFocusMarker',//regNo,
                    // content:'<div class="mumb_marker_pin" style="background: #f67723;"></div>',
                    content: `<img src="../../../assets/map_images/routeMarker.png">`,
                    lat: parseFloat(lat),
                    lng: parseFloat(lng),
                    cluster: 'dashboardMap',
                  }
                  parent.mapObj.marker(marker);
                  parent.focus({ 'lat': lat, 'lng': lng });
                }
              },
              mouseOut: function () {
                if (parent.routeMarker) {
                  parent.routeMarker.setMap(null);
                }
              },
            }
          },
        },
      },

      series: [{
        type: 'area',
        name: 'Speed',
        data: data,
        turboThreshold: 0
      }]
    });
  }
  removeLineChart() {
    let container;
    if (this.selectedMap == 'google') {
      container = document.getElementById('routeChartContainer');
    } else {
      this.mapObj.removeMarker('_dashboardFocusMarker');
      container = document.getElementById('routeChartContainer');
    }
    this.plotlineChart = undefined;
    if (container) {
      container.style.display = 'none';
      container.style.height = '0px';
    }
  }
  placeMarker(markers) {
    this.googleMapMarkers = [];
    this.googleMapMarkers = markers;
    for (let i = 0; i < this.googleMapMarkers.length; i++) {
      if (this.googleMapMarkers[i] != undefined) {
        this.googleMapMarkers[i].setMap(this.googleMapObj);
      }
    }
    const clusteringOptions = {
      styles: [{
        url: "assets/images/map/googleMap/m1.png",
        width: 53,
        height: 53,
        textSize: 12,
        textColor: "white",
      }],
      minimumClusterSize: 2,
      maxZoom: 14
    };
    if (this.googleMapObj) {
      this.deviceMarkerClusters = new MarkerClusterer(
        this.googleMapObj, this.googleMapMarkers,
        clusteringOptions
      );
    }
  }
  initGoogleMap() {

  }
  initMap(markers: any, type: string) {
    // this.globalGoogleMarker=markers;
    if (this.selectedMap == 'google') {
      // if(this.googleMapObj.map==null){
      //   this.googleMapObj = new google.maps.Map(document.getElementById(this.gMapId), this.mapOptions);
      //   const trafficLayer = new google.maps.TrafficLayer();
      //   trafficLayer.setMap(this.googleMapObj);
      // }
      if (!this.showSingleVeh) {
        if (this.activeVehGglMarkers.length > 0) {
          for (let i = 0; i < this.activeVehGglMarkers.length; i++) {
            this.activeVehGglMarkers[i].setMap(this.googleMapObj);
          }
        }
      }
      // this.googleMapObj.setZoom(7);
      // setTimeout(()=>{
      // const mapOptions = {
      //   scrollwheel: true,
      //   zoom: 5,
      //   maxZoom: 17,
      //   center: new google.maps.LatLng(20.5937, 78.9629),
      //   fullscreenControl: false,
      //   zoomControl: true,
      //   zoomControlOptions: {
      //     position: google.maps.ControlPosition.LEFT_TOP,
      //   },
      //   mapTypeControl: true,
      //   mapTypeControlOptions: {
      //     style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      //     position: google.maps.ControlPosition.TOP_CENTER,
      //   },
      //   streetViewControl: false,
      // };
      // this.googleMapObj = new google.maps.Map(document.getElementById('markerExampleMapBox1'), mapOptions);
      // this.placeMarker(markers);
      // },1000)
    } else {
      try {
        const mapBoxKey = 'pk.eyJ1Ijoib3dlbmxhbWIiLCJhIjoiY2lleWljcnF4MDBiOXQ0bHR0anRvamtucSJ9.t3YnHHqvQZ8Y0MTCNy0NNw';
        const parent = this;
        if (mapBoxKey) {
          const MyMap1 = new mapUtilityMapBox();
          MyMap1.setup('markerExampleMapBox1', {
            key: mapBoxKey
          },
            function (map) {
              // if (type == 'add') {
              parent.mapObj = map;
              // console.log('inside mapObject',parent.mapObj);
              map.clusters = [
                {
                  name: 'dashboardMap',  // unique id
                  maxZoom: 10, // max zoom on cluster click event
                  radius: 20,
                  color: 'rgba(255, 0, 0, 0.2)', // '#be9694'  // for opacity use rgb
                  textColor: 'green' // count color
                }
              ];
              markers = markers.filter(function (element) {
                return element !== undefined;
              });
              if (markers.length > 0) {

                map.addMarkers(markers);
                setTimeout(() => {
                  map.clusterSynch();
                }, 1000);

                map.onMapZoom((z) => {
                  /* show vehicle Reg No when zoom level is above 13 */
                  if (z >= 13) {
                    if (parent.map_marker_vehRegNo_style == 'hidden') {
                      const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                      for (let i = 0; i < veh_Reg_nums.length; i++) {
                        const elem: any = veh_Reg_nums[i];
                        elem.style.visibility = 'visible';
                      }
                      parent.map_marker_vehRegNo_style = 'visible';
                    }
                  }
                  else {
                    if (parent.map_marker_vehRegNo_style == 'visible') {
                      const veh_Reg_nums = document.querySelectorAll('.map_marker_vehRegNo');
                      for (let i = 0; i < veh_Reg_nums.length; i++) {
                        const elem: any = veh_Reg_nums[i];
                        elem.style.visibility = 'hidden';
                      }
                      parent.map_marker_vehRegNo_style = 'hidden';
                    }
                  }

                  map.clusterSynch();
                  setTimeout(() => { map.marker(markers); }, 10);
                });

                map.onMouseOver({
                  type: 'marker',
                }, (h) => {
                  if (h.id) {
                    if (h.id.split('_')[6] && parent.plotlineChart) {
                      let indexVal = h.id.split('_')[6];
                      if (indexVal) {
                        if (h.id.split('_')[5] == 'start') indexVal = 0;
                        else if (h.id.split('_')[5] == 'end') indexVal = parent.plotlineChart.series[0].data.length - 1;
                        else indexVal = Number(h.id.split('_')[6]) + 1;
                        parent.plotlineChart.series[0].data[indexVal].setState("hover");
                        parent.plotlineChart.tooltip.refresh(parent.plotlineChart.series[0].data[indexVal]);
                        map.removeMarker('_dashboardFocusMarker');
                      }
                    }
                  }
                })

                // console.log(markers[0])
                // map.focus({
                //   lat: parseFloat(markers[0].lat),
                //   lng: parseFloat(markers[0].lng),
                //   zoom: 10
                // });

                map.onClick({
                  type: 'marker',
                }, (e: any) => {
                  map.focus({
                    lat: e._lngLat.lat,
                    lng: e._lngLat.lng,
                    zoom: 18
                  });
                });
              }
              // } else {
              //   console.log(markers)
              //   map.marker(markers);
              //   setTimeout(() => {
              //     map.clusterSynch();
              //   }, 500);
              // }
            });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }


  updateMarker(marker) {
    // console.log('marker ', marker)
    if (marker !== undefined) {
      if (this.selectedMap == 'google') {
        let loc = {
          lat: +marker.position.lat(),
          lng: +marker.position.lng()
        }
        let index = this.activeVehGglMarkers.findIndex((e) => e.id == marker.id);
        if (index != -1) {
          if (this.activeVehGglMarkers.length > 0) {
            for (let i = 0; i < this.activeVehGglMarkers.length; i++) {
              if (i == index) {
                this.activeVehGglMarkers[index].setPosition(loc);
                this.activeVehGglMarkers[index].setMap(this.googleMapObj);
              } else {
                this.activeVehGglMarkers[i].setMap(null);
              }
            }
          }
        }
        // this.googleMapObj.panTo(new google.maps.LatLng(loc.lat,loc.lng));
      } else {
        this.mapObj.addMarkers([{ ...marker }]);
      }
    }
    //if (marker !== undefined) this.mapObj.marker(marker);

  }

  updateAllMarkers(markers) {
    if (this.selectedMap == 'google') {
      this.globalGoogleMarker = markers;
      this.placeMarker(this.globalGoogleMarker);
    } else {
      if (this.mapObj) {
        this.mapObj.removeMarkerAll();
        setTimeout(() => { this.mapObj.addMarkers(markers); this.mapObj.clusterSynch(); }, 200);
      }
    }
  }
  focusSingleVeh(obj) {
    setTimeout(() => {
      if (this.mapObj !== undefined) {
        this.mapObj.removeMarkerAll();
      }
      const marker = [];
      let singleMarker;
      singleMarker = this.getVehicleMarker(obj);
      marker.push(singleMarker);
      this.updateMarker(singleMarker);
      /* const color = obj['spd'] > 5 ? 'green-dot' : 'red-dot';
      const marker = [{
        id: obj['reg'],//regNo,
        content: `<div class="${color} "></div>
        <span class="mumb_marker_marker-label" style="visibility: visible;">${obj['reg'].toUpperCase()}</span>`,
        lat: parseFloat(obj['lat']),
        lng: parseFloat(obj['lng']),
        popup: {
          content: '<span>' + obj['reg'] + '<span>',
          open: false
        },
        bearing: true,
      }]; */
      //this.initMap(marker,'add');
      setTimeout(() => {
        // this.mapObj.addMarkers(marker);
        if (this.selectedMap != 'google') {
          this.focus(singleMarker);
        }
      }, 200);

      //this.createSummary();   //create summary static data
    }, 500);
  }

  removeSingleVeh(obj) {
    let id = obj['reg'];
    //this.mapObj.removeMarker(id);
    // console.log("triggggggressss11111111--------->>>>")
    this.getCurrentVehicleLocation();
  }

  focus(e) {
    const obj = {
      lat: e.lat,
      lng: e.lng,
      zoom: 13
    };
    // console.log(obj, 'this.mapObj', this.mapObj);
    this.mapObj.focus(obj);
  }
  getCurrentVehicleLocation() {
    // console.log("calllssssssss->>>>>>>>>>", )

    try {
      const markers = [];

      this.api.getCurrentLocation({}).then((res: any) => {
        if (res.status == 'success') {
          if (res.data.length > 0) {
            res.data.map((item: any, i: number) => {
              // const regNo: any = Object.keys(item)[0];

              let data = {};
              try {

                if (typeof item === 'string') item = JSON.parse(item);
                // console.log(item)
                if (item.gpsts) {
                  let currnentTMS = new Date().getTime();
                  let gpsts = item.gpsts
                  if ((gpsts + '').length <= 10) gpsts = gpsts * 1000;
                  const timeDiff = this.comService.timeDiff(gpsts, currnentTMS);
                  if (timeDiff.hh <= 72) {
                    data = item;//[regNo];
                  } else {
                    data = undefined;
                  }
                }
              } catch (error) {

              }
              if (data !== undefined && Object.keys(data).length > 0) {
                // console.log("data from live tracking-------->", data, i)
                this.socketStore.addVehicleInfo(data);
                const currnentTMS = new Date().getTime();

                const restrictedDays = new Date().setDate(new Date().getDate() - 2);
                const restrictedDatetime = new Date(restrictedDays).setHours(0, 0, 0, 0);
                const restrictedTimestamp = new Date(restrictedDatetime).getTime();
                let marker = this.getVehicleMarker(data);
                markers.push(marker);
                /* if ((restrictedTimestamp <= (data['gpsts'].length > 10 ? data['gpsts'] : data['gpsts'] * 1000))) {

                  try{
                    if((marker.lat < 90 && marker.lat > -90) && (marker.lng < 90 && marker.lng > -90))
                  }catch(err){
                    console.error('Marker Error!')
                  }

                } */
                // console.log(data)
                // console.log(marker)

              }
              if (res.data.length - 1 == i) {
                this.vehicleStatus.emit(data);
                if (this.initialMapLoad) {
                  // console.log('Init markers ', markers);
                  this.initMap(markers, 'add');
                  // this.initGoogleMap()
                }
                else {
                  this.mapObj.removeMarkerAll();
                  setTimeout(() => {
                    this.mapObj.addMarkers(markers);
                  }, 100);

                }
              }
            });
          } else {
            this.initMap([], 'add');
          }
        }
        else {
          this.initMap([], 'add')
        }
      });
    } catch (error) {
      console.log('Error', error);
    }
  }

  getVehicleMarker(data) {
    let color = 'orange-dot';
    if (data.gpsts && data.gpsts != undefined) {
      let currnentTMS = new Date().getTime();
      let gpsts = data.gpsts
      if ((gpsts + '').length <= 10) gpsts = gpsts * 1000;
      const timeDiff = this.comService.timeDiff(gpsts, currnentTMS);
      if (timeDiff.hh > 4) {
        color = 'orange-dot';
      } else {
        color = data.spd > 5 ? (data.spd < 60 ? 'green-dot' : 'blue-dot') : 'red-dot'
      }
      let marker;
      if (this.selectedMap == 'google') {
        marker = this.createGoogleMarker(data);
        // let infoWindowContent;
        // let infowindow;
        // let location={
        //   lat: parseFloat(data['lat']),
        //   lng: parseFloat(data['lng']),
        // }
        // let image = {
        //   scaledSize: new google.maps.Size(10, 10),
        // };
        // if(timeDiff.hh>4){
        //   image['url']= "assets/images/map/googleMap/map_orange.png";
        // }else{
        //   image['url'] = data.spd > 5 ? (data.spd<60 ? 'assets/images/map/googleMap/map_green.png' : 'assets/images/map/googleMap/map_blue.png') : 'assets/images/map/googleMap/map_red.png'
        // }
        // marker= new google.maps.Marker({
        //   position: location,
        //   icon: image,
        //   updated:data.gpsts,
        //   speed:data.spd
        // })
        // marker.addListener('click',(e)=>{
        //   if(infowindow) infowindow.close();
        //   infoWindowContent = '<div class="window-content-container"><span style="font-weight:700">' + data.reg + '</span><div style="margin-top:2px">'+'Updated :'+'<span>'+' '+this.comService.timestampToDate(data.gpsts*1000)+'</span></div><div style="margin-top:2px">'+'Speed :'+' '+'<span>'+data.spd+' '+'kmph' +'</span>'+'</div>'+'</div>';
        //   infowindow = new google.maps.InfoWindow({
        //     content: infoWindowContent
        //   });
        //   this.googleMapObj.setZoom(15);
        //   this.googleMapObj.panTo(location);
        // })
        // google.maps.event.addListener(marker, 'click', function() {
        //   infowindow.open(this.googleMapObj, this);
        // });
      } else {
        marker = {
          id: '_dashboard' + data['reg'],//regNo,
          content: `<div class="${color} "></div>
          <span class="mumb_marker_marker-label map_marker_vehRegNo">${data['reg'].toUpperCase()}</span>`,
          lat: parseFloat(data['lat']),
          lng: parseFloat(data['lng']),
          /* popup: {
            content: '<span>' + data['reg'] + '<span>',
            open: false
          }, */
          cluster: 'dashboardMap',
          // bearing: true,
        };
      }

      return marker;
    }
  }

  getRegNos() {

    this.api.getOrgVehicleRegNos({}).then((res: any) => {
      if (res.status == 'success') {
        this.vehicleRegNos = res.data;
      }
    }).catch((err) => {
      // console.log(err);
    });
  }


  async createSummary() {
    // let obj = {"regNo": "dl07CP8975",  "startDate": 1635705060000,  "endDate": 1635877740000 };
    // let obj = {"regNo": "dl65AP6655",  "startDate": 1635705060000,  "endDate": 1635791340000 };
    let obj = { "regNo": "Tn01AA9943", "startDate": 1636569060000, "endDate": 1636655340000 };
    const startDate = new Date(obj['startDate']);
    const endDate = new Date(obj['endDate']);
    const arr: any = []
    const pad = this.comService.pad;

    let getDaysArray: any = function (start, end) {
      for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
        const date = new Date(dt);
        arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
      }
      return arr;
    };
    const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
    const end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate())

    const daylist: any = getDaysArray(new Date(start), new Date(end));

    const timeIntravel = 300;
    const speed = 10;

    for (let day = 0; day < daylist.length; day++) {

      const splitDate = daylist[day].split('/');
      const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
      if (obj['regNo'] != null && this.vehicleRegNos[obj['regNo']] != null) {
        const url = date + '/' + this.vehicleRegNos[obj['regNo']] + '.z';
        // console.log(url);
        /* const res:any = await this.api.readS3Data(url);
        console.log(res);
        if(res){
          let wayPointsLocations = res.map((pp)=>{
            let item = pp;
          //   let item = pp.pickupInfo;
            return [item.lat, item.lng];
            });

            // setTimeout func place here
          } */
        this.mapObj.removeLine('dashboardvehicle');
        setTimeout(() => {
          // console.log('add line obj',this.mapObj);
          this.mapObj.addLine({
            id: 'dashboardvehicle',
            locations: [
              [12.970225, 80.214339, {
                title: 'start Location',
                plotMarker: '<div class="mumb_marker_pin" style="background: green;"></div><div class="mumb_marker_pulse" style="background: green;"></div>',
              }],
              [12.969689, 80.215030],
              [12.969037, 80.215850],
              [12.968238, 80.217102, {
                title: '4th point, 🕐 : 10:00AM ',
                plotMarker: '<div class="mumb_marker_pulse" style="background: black; width: 10px;"></div>'
              }],
              [12.967165, 80.217318],
              [12.965406, 80.216636],
              [12.962297, 80.215467],
              [12.959891, 80.214491,
                {
                  title: '9th point, 🕐 : 12:00PM ',
                  plotMarker: '<div class="mumb_marker_pulse" style="background: black; width: 10px;"></div>'
                }
              ],
              [12.958042, 80.213717],
              [12.954703, 80.212465],
              [12.949897, 80.210525],
              [12.949897, 80.210525],
              [12.945248, 80.208683,
                {
                  title: '14th point, 🕐 : 2:00PM ',
                  plotMarker: '<div class="mumb_marker_pulse" style="background: black; width: 10px;"></div>'
                }],
              [12.943506, 80.207946, {
                title: 'start Location',
                plotMarker: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div>'
              },],
            ],
            //locations: wayPointsLocations,
            color: 'black',
            width: 2,
            animation: false,
            bearingFocus: true,
            lineBearing: 1 * 500,
            drawArrow: {
              colorClass: 'secondary'
            }
          });
        }, 1000);
      }
    }

  }
  deleteSummary() {
    // console.log('delete summary',this.summaryInfo);
  }
  removeLine() {
    if (this.selectedMap == 'google') {
      for (let i = 0; i < this.googleMapMarkers.length; i++) {
        if (this.googleMapMarkers[i] != undefined) {
          this.googleMapMarkers[i].setMap(null);;
        }
      }
    } else {
      this.mapObj.removeLineArrow([`g10_dashboard_single_vehicle_line`]);

      let removerMarkers = Object.keys(this.mapObj['liveMarkers']);
      let markers = []
      if (removerMarkers.length > 0) {
        for (let m = 0; m < removerMarkers.length; m++) {
          if (removerMarkers[m] && removerMarkers[m] != undefined) {
            if (removerMarkers[m].includes(`g10_dashboard_single_vehicle_line`)) markers.push(removerMarkers[m]);
          }
        }
      }
      setTimeout(() => {
        this.mapObj.removeMarker(markers);
        this.mapObj.removeLine([`g10_dashboard_single_vehicle_line`]);
      }, 100);
    }

  }
  plotSingleVehicleLine(locations: []) {
    // console.log('locations',locations);
    this.mapObj.removeLineArrow([`g10_dashboard_single_vehicle_line`]);
    this.mapObj.removeLine([`g10_dashboard_single_vehicle_line`]);

    setTimeout(() => {
      this.mapObj.addLine({
        id: 'g10_dashboard_single_vehicle_line',
        locations: locations,
        color: 'black',
        width: 2,
        // dash : 2,
        animation: false,
        lineBearing: 1 * 100,
        startMarker: '<div class="mumb_marker_pin" style="background: green;"></div><div class="mumb_marker_pulse" style="background: green;"></div>',
        //bearingMarker : '<div class="mumb_marker_car_red"></div>', //'<img src="map-assets/images/ripple-circle.gif">' 
        bearingFocus: true,
        // plotMarker: '<div class="mumb_marker_circle" style="background: #6264a7; width: 10px;"></div>',
        endMarker: '<div class="mumb_marker_pin" style="background: red;"></div><div class="mumb_marker_pulse" style="background: red;"></div>',
        drawArrow: {
          colorClass: 'secondary'
        }
      });
      // console.log('map obj',this.mapObj);
    }, 200);

  }

  resetVehicle() {
    const markers = [];
    this.socketStore.get().filter((item: any) => {
      let marker = this.getVehicleMarker(item);
      markers.push(marker);
    });
    setTimeout(() => {
      this.updateAllMarkers(markers);
    }, 100)
  }
  changePlotSpeed(speed) {
    this.selectedSpeed = speed;
    if (this.showSingleVeh) {
      let selectedSpeedElem = document.getElementById('selectedSpeed');
      if (this.selectedSpeed == 50) {
        selectedSpeedElem.innerHTML = '10x';
      } else if (this.selectedSpeed == 200) {
        selectedSpeedElem.innerHTML = '5x';
      } else if (this.selectedSpeed == 500) {
        selectedSpeedElem.innerHTML = '4x';
      } else if (this.selectedSpeed == 1000) {
        selectedSpeedElem.innerHTML = '3x';
      } else if (this.selectedSpeed == 1500) {
        selectedSpeedElem.innerHTML = '2x';
      } else if (this.selectedSpeed == 2000) {
        selectedSpeedElem.innerHTML = '1x';
      }
    }
  }
}
